import request from "@/util/http"; // 教室查询-列表查询

export var getClassRoomPage = function getClassRoomPage(params) {
  return request({
    url: "/hq/classroom/page",
    method: "get",
    params: params
  });
}; //教室查询-下载二维码

export var getClassRoomDownId = function getClassRoomDownId(params) {
  return request({
    url: "/hq/classroom/roomQR",
    method: "get",
    params: params
  });
}; // 教室查询-批量下载二维码

export var getClassRoomDown = function getClassRoomDown(params) {
  return request({
    url: "/hq/classroom/exportQRzip",
    method: "post",
    data: params
  });
};